import { StrategyDetailsPageInvestmentEntitiesQuery } from '@/__generated__/graphql';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import NoResults from '@/components/table/noResults';
import RedirectTitleCell from '@/components/table/redirectTitleCell';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import { TableColumns } from '@/components/table/types';
import { useAuth } from '@/hooks/use-auth';
import guid from '@/shared/utils/guid';
import { formatPercentage } from '@/shared/utils/percentage';
import { TenantType } from '@trace-8/trace8-schema';
import styled from 'styled-components';

interface TabelBodyEntityProps {
  entityTableRows: StrategyDetailsPageInvestmentEntitiesQuery['InvestmentEntities']['entities'];
  columns: TableColumns[];
  openInvestorDetailsPage: ({ investorId, entityId }: { investorId: string; entityId?: string }) => void;
}

const TabelBodyEntity = ({ entityTableRows, columns, openInvestorDetailsPage }: TabelBodyEntityProps) => {
  const { user } = useAuth();

  if (!entityTableRows?.length) {
    return <NoResults />;
  }

  return (
    <>
      {entityTableRows.map((row) => (
        <CustomTableRowWrapper key={row.id}>
          <TableRowCell width={columns[0].width}>
            <RedirectTitleCell id="actionCurioText" onClick={() => openInvestorDetailsPage({ investorId: row.familyId, entityId: row.id })}>
              {row.name}
            </RedirectTitleCell>
          </TableRowCell>
          <TableRowCell width={columns[1].width}>
            <RedirectTitleCell id="actionCurioText" onClick={() => openInvestorDetailsPage({ investorId: row.familyId })}>
              {row.family}
            </RedirectTitleCell>
          </TableRowCell>
          <TableRowCell width={columns[2].width}>
            {user && user.tenant.type === TenantType.PLATFORM_MANAGER && <TextCell>{row.tenant.name}</TextCell>}
          </TableRowCell>
          <TableRowCell width={columns[3].width}>
            <TextCell>{row.vehicle}</TextCell>
          </TableRowCell>
          <TableRowCell width={columns[4].width}>
            <TextCell>
              <FormattingTooltip zIndex={1000} key={guid()}>
                {row.committedCapital}
              </FormattingTooltip>
            </TextCell>
          </TableRowCell>
          <TableRowCell width={columns[5].width}>
            <TextCell>
              <FormattingTooltip zIndex={1000} key={guid()}>
                {row.capitalCalled}
              </FormattingTooltip>
            </TextCell>
          </TableRowCell>
          <TableRowCell width={columns[6].width}>
            <TextCell>{formatPercentage(row.percentOfCapitalCalled)}</TextCell>
          </TableRowCell>
        </CustomTableRowWrapper>
      ))}
    </>
  );
};

export default TabelBodyEntity;

const CustomTableRowWrapper = styled(TableRowWrapper)`
  justify-content: space-between;
  gap: 16px;
`;
